module.exports = __webpack_public_path__ + "img/fenceend2.a6cffe59.webp";